import { observer } from "mobx-react";
import React from "react";
import adminStore from "../stores/adminStore";
import DataTable from "./DataTable";
import Pagination from "@material-ui/lab/Pagination"
import { Button } from "@material-ui/core";
import { scoreByData} from "./Charts/ScoreByArea";
import { csvFormat } from 'd3-dsv'
import saveAs from 'file-saver'


@observer
class Users extends React.Component {
    constructor(props) {
        super(props)
        this.state = {page: 1, viewUser: undefined}
    }

   download() {
       let columns = ['Nombre', 'Apellido', 'DNI', 'EMail', 'Area', 'Cargo', 'Score' ]
       const info = adminStore.users.map(u => {
           let obj = {
               "Nombre": u.first_name,
               "Apellido": u.last_name,
               "DNI": u.dni,
               "EMail": u.email,
               "Area": u.area,
               "Cargo": u.ocupation,
               "Score": u.score,
           }
           u.competences.forEach(c => {
               obj[c.name] = c.score
               if (columns.indexOf(c.name) === -1) columns.push(c.name)
           })
           return obj
       })
       const text = csvFormat(info, columns)
       const blob = new Blob([text], { type: 'text/csv' })
       if (blob) saveAs(blob, 'usuarios.csv')
   }

   render() {
        const { users } = adminStore;
        if (!users) {
            return <div></div>;
        }
        const { viewUser } = this.state

        if (viewUser !== undefined) {
            return (
                <div>
                    <div style={{float: "right"}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.setState({ viewUser: undefined }) }
                        >
                            Volver
                        </Button>
                    </div>
                    <h3>{viewUser.first_name} {viewUser.last_name} {viewUser.score}</h3>
                    <h4> {viewUser.area} - {viewUser.ocupation} </h4>
                    { scoreByData(viewUser.competences) }
                    <DataTable
                        data={viewUser.answers}
                        fields={[
                            "question",
                            "answer",
                            "score",
                        ]}
                        fieldNames={{
                            question: "Pregunta",
                            answer: "Respuesta",
                            score: "Score",
                        }}
                        editButton={false}
                        deleteButton={false}
                    />
                </div>
            )
        }

        return (
            <div>
                <div style={{float: "right"}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.download() }
                    >
                        Descargar
                    </Button>
                    <br /> <br />
                </div>
                <DataTable
                    data={users}
                    fields={[
                        "id",
                        "first_name",
                        "last_name",
                        "email",
                        "dni",
                        "area",
                        "ocupation",
                        "score",
                        "finished",
                    ]}
                    fieldNames={{
                        id: "#",
                        first_name: "Nombre",
                        last_name: "Apellido",
                        email: "Email",
                        area: "Area",
                        dni: "Documento",
                        ocupation: "Cargo",
                        score: "Score",
                        finished: "Finalizo?",
                    }}
                    fieldFormats={{
                        finished: (f) => (f ? "SI" : "NO"),
                    }}
                    viewButton={true}
                    editButton={false}
                    deleteButton={false}
                    onView={x => this.setState({viewUser: x})}
                />
                { false && // Agregar el query con la pagina
                <Pagination count={10} onChange={(e, v) => this.setState({page: v})}/>
                }
            </div>
        );
    }
}

export { Users };

